import script from "./DocsResponseBody.vue?vue&type=script&setup=true&lang=js"
export * from "./DocsResponseBody.vue?vue&type=script&setup=true&lang=js"

import "./DocsResponseBody.vue?vue&type=style&index=0&id=6286301a&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6286301a"]])

export default __exports__